import { Box } from '@material-ui/core';
//import Navbar from './Navbar';
import styles from './Navbar.module.scss';

const Header: React.FC = () => (
    <Box display="flex" flexDirection="column" className={styles.header}>
        {/* {process.env.NODE_ENV !== 'production' && <Navbar />} */}
    </Box>
);

export default Header;
